/**
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
export var SIDE_PANEL_SIZES = {
  xs: '16rem',
  sm: '20rem',
  md: '30rem',
  lg: '40rem',
  max: '75%'
};